const queryKeys = {
  all: ['dashboarddetails'] as const,
  dashboardall: (dashboardid: string) => [...queryKeys.all, dashboardid] as const,
  dashboardentity: (dashboardid: string, entity: string) => [...queryKeys.dashboardall(dashboardid), entity],
};

export default queryKeys;